export const lmsReportType = {
  GET_LMS_REPORT_PENDING: "[GET_LMS_REPORT][REQUEST] GET LMS REPORT Requested",
  GET_LMS_REPORT_FAILURE: "[GET_LMS_REPORT][RESPONSE] GET LMS REPORT Failed",
  GET_LMS_REPORT_SUCCESS:
    "[GET_LMS_REPORT][RESPONSE] GET LMS REPORT  Successfull",
  LMS_REPORT_PAGE: "LMSREPORTPAGE",

  GET_LMS_REPORT_COURSE_PENDING:
    "[GET_REPORT_COURSES][REQUEST] GET LMS REPORT COURSE Requested",
  GET_LMS_REPORT_COURSE_FAILURE:
    "[GET_REPORT_COURSES][RESPONSE] GET LMS REPORT COURSE Failed",
  GET_LMS_REPORT_COURSE_SUCCESS:
    "[GET_REPORT_COURSES][RESPONSE] GET LMS REPORT COURSE  Successfull",
  LMS_REPORT_COURSE_PAGE: "LMSREPORTCOURSEPAGE",

  GET_LMS_REPORT_LESSON_PENDING:
    "[GET_REPORT_LESSON][REQUEST] GET LMS REPORT LESSON Requested",
  GET_LMS_REPORT_LESSON_FAILURE:
    "[GET_REPORT_LESSON][RESPONSE] GET LMS REPORT LESSON Failed",
  GET_LMS_REPORT_LESSON_SUCCESS:
    "[GET_REPORT_LESSON][RESPONSE] GET LMS REPORT LESSON  Successfull",
  LMS_REPORT_LESSON_PAGE: "LMSREPORTLESSONPAGE",

  GET_LMS_DASHBOARD_REPORT_PENDING:
    "[GET_DASHBOARD_REPORT][REQUEST] GET LMS DASHBOARD REPORT Requested",
  GET_LMS_DASHBOARD_REPORT_FAILURE:
    "[GET_DASHBOARD_REPORT][RESPONSE] GET LMS DASHBOARD REPORT Failed",
  GET_LMS_DASHBOARD_REPORT_SUCCESS:
    "[GET_DASHBOARD_REPORT][RESPONSE] GET LMS DASHBOARD REPORT  Successfull",

  GET_LMS_DASHBOARD_REPORT_DETAILS_PENDING:
    "[GET_DASHBOARD_REPORT_DETAILS][REQUEST] GET LMS DASHBOARD REPORT_DETAILS Requested",
  GET_LMS_DASHBOARD_REPORT_DETAILS_FAILURE:
    "[GET_DASHBOARD_REPORT_DETAILS][RESPONSE] GET LMS DASHBOARD REPORT_DETAILS Failed",
  GET_LMS_DASHBOARD_REPORT_DETAILS_SUCCESS:
    "[GET_DASHBOARD_REPORT_DETAILS][RESPONSE] GET LMS DASHBOARD REPORT_DETAILS  Successfull",
  CLEAR_LMS_DASHBOARD_REPORT_DETAILS:
    "[GET_DASHBOARD_REPORT_DETAILS][RESPONSE] CLEAR LMS DASHBOARD REPORT_DETAILS ",

  GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_PENDING:
    "[GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_PENDING][REQUEST] GET LMS DASHBOARD Course lesson safetymeeting comp Requested",
  GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_FAILURE:
    "[GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_FAILURE][RESPONSE] GET LMS DASHBOARD Course lesson safetymeeting comp Failed",
  GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_SUCCESS:
    "[GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_SUCCESS][RESPONSE] GET LMS DASHBOARD Course lesson safetymeeting comp Successfull",

  CLEAR_LMS_DASHBOARD_REPORT_LESSON_COURSE_SAFETY_COMPLETED:
    "[CLEAR_LMS_DASHBOARD_REPORT_LESSON_COURSE_SAFETY_COMPLETED][RESPONSE] CLEAR LMS DASHBOARD REPORT_DETAILS ",

  GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_INCOMPLETED_PENDING:
    "[GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_INCOMPLETED_PENDING][REQUEST] GET LMS DASHBOARD Course lesson safetymeeting Incomp Requested",
  GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_INCOMPLETED_FAILURE:
    "[GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_INCOMPLETED_FAILURE][RESPONSE] GET LMS DASHBOARD Course lesson safetymeeting Incomp Failed",
  GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_INCOMPLETED_SUCCESS:
    "[GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_INCOMPLETED_SUCCESS][RESPONSE] GET LMS DASHBOARD Course lesson safetymeeting Incomp Successfull",

  CLEAR_LMS_DASHBOARD_REPORT_LESSON_COURSE_SAFETY_INCOMPLETED:
    "[CLEAR_LMS_DASHBOARD_REPORT_LESSON_COURSE_SAFETY_COMPLETED][RESPONSE] CLEAR LMS DASHBOARD REPORT_DETAILS ",

  LMS_DASHBOARD_REPORT_LESSON_COURSE_SAFETY_COMPLETED_PAGE:
    "[LMS_DASHBOARD_REPORT_LESSON_COURSE_SAFETY_COMPLETED_PAGE][RESPONSE]  LMS DASHBOARD REPORT_DETAILS ",

  GET_LMSREPORT_LIST_EMAIL_SUCCESS:
    "[GET_LMSREPORT_LIST_EMAIL_SUCCESS][RESPONSE] GET LMSREPORT LIST EMAIL SUCCESS",

  GET_COURSELECTION_MAIL_SUCCESS:
    "[GET_COURSELECTION_MAIL_SUCCESS][RESPONSE] GET COURSE SELECTION MAIL SUCCESS",
  GET_LMS_SCORMLIST_REPORT_PENDING:
    "[GET_LMS_SCORMLIST_REPORT_PENDING][REQUEST] GET LMS REPORT Requested",
  GET_LMS_SCORMLIST_REPORT_FAILURE:
    "[GET_LMS_SCORMLIST_REPORT_FAILURE][RESPONSE] GET LMS REPORT Failed",
  GET_LMS_SCORMLIST_REPORT_SUCCESS:
    "[GET_LMS_SCORMLIST_REPORT_SUCCESS][RESPONSE] GET LMS REPORT  Successfull",
  LMS_SCORMREPORT_PAGE: "LMSSCORMREPORTPAGE",
  CLEAR_LMS_DASHBOARD_GET_LMS_SCORMLIST_REPORT:
    "[CLEAR_LMS_DASHBOARD_GET_LMS_SCORMLIST_REPORT][RESPONSE] CLEAR LMS DASHBOARD REPORT_DETAILS ",

  GET_LMS_SCORM_REPORT_LIST_EMAIL_SUCCESS:
    "[GET_LMS_SCORM_REPORT_LIST_EMAIL_SUCCESS][RESPONSE] GET LMSREPORT LIST EMAIL SUCCESS",

  GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_SUCCESS_EMAIL:
    "[GET_LMS_DASHBOARD_COURSE_LESSON_SAFETYMETTING_COMPLETED_SUCCESS_EMAIL][RESPONSE] GET LMS DASHBOARD Course lesson safetymeeting comp Successfull EMAIL",
};
